<template lang="html">
  <v-container grid-list-xs,sm,md,lg,xl>
    <v-layout row wrap>
      <v-flex
        xs12
        sm10 offset-sm1
        md8 offset-md2
        xl4 offset-xl4
        mt-5
      >
        <v-card>
          <v-container pa-0 grid-list-xs,sm,md,lg,xl>
            <v-layout row wrap v-if="error">
              <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card-title class="headline">
                  Sign Up
                </v-card-title>
                <v-card-text>
                  <form @submit.prevent="onSignup">
                    <v-text-field
                      autocomplete="username"
                      label="User Name"
                      v-model="displayName"
                      type="text"
                      required
                    ></v-text-field>
                    <v-text-field
                      autocomplete="email"
                      label="Email"
                      v-model="email"
                      type="email"
                      :rules="[verifyEmailDomain]"
                      required
                    ></v-text-field>
                    <v-text-field
                      autocomplete="new-password"
                      label="Password"
                      v-model="password"
                      type="password"
                      required
                    ></v-text-field>
                    <v-text-field
                      autocomplete="new-password"
                      label="Confirm Password"
                      v-model="confirmPassword"
                      type="password"
                      :rules="[comparePasswords]"
                    ></v-text-field>
                    <v-card-actions class="px-0">
                      <v-btn
                        type="submit"
                        color="primary"
                        flat
                        :disabled="loading"
                        :loading="loading"
                      >Sign Up
                        <span slot="loader" class="custom-loader"><v-icon>cached</v-icon></span>
                      </v-btn>
                    </v-card-actions>
                  </form>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      email: '',
      displayName: '',
      password: '',
      confirmPassword: ''
    }
  },
  computed: {
    comparePasswords () {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : true
    },
    verifyEmailDomain () {
      const allowedDomains = [
        'sunpeakpower.com'
      ]
      let domain = this.email.replace(/.*@/, '') // extract the domain from string
      let match = false
      for (let i = 0; i < allowedDomains.length; i++) {
        // set match to true when one is found
        match = allowedDomains[i] === domain ? true : match
      }
      return match ? true : 'Must be SunPeak, or SunPeak partner company email address'
    },
    ...mapGetters({
      loading: 'loading',
      error: 'error',
      userIsAuthenticated: 'user/isAuthenticated'
    })
  },
  watch: {
    userIsAuthenticated (authenticated) {
      // redirect home when/if user is signed in
      if (authenticated) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    onSignup () {
      if (this.comparePasswords === true && this.verifyEmailDomain === true) {
        this.$store.dispatch('user/signUp', {email: this.email, password: this.password, displayName: this.displayName})
      }
    },
    onDismissed () {
      this.$store.commit('clearError')
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/pages/SignUp.vue